import { Row, Col, Form, Checkbox, Input, Select, Radio } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_screenvr_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const { Option } = Select;

const ScreenNameVR = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.screennamevr_form_type);
  const handleFormChange = debounce((changedValues) => {
    dispatch(update_screenvr_form(changedValues));
    onValuesChange(formData);
  }, 300);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Row>
        <Col span={16} style={{ fontWeight: "bold" }}>
          Screen Name: VOTER REGISTRATION
        </Col>
        <Col span={8}>
          <Form.Item
            name="Status"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select defaultValue="Selected Status" style={{ width: 200 }}>
              <Option value="Selected Status">
                <strong>Selected Status</strong>
              </Option>
              <Option value="N/A">N/A</Option>
              <Option value="COMPLETE">COMPLETE</Option>
              <Option value="PENDING">PENDING</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        MUST BE VERBALLY ASKED AND CLIENT RESPONSE RECORDED (At Application
        ONLY)
        <Form.Item
          name="Would you like to register to vote?"
          label="Would you like to register to vote?"
          rules={[
            {
              required: true,
            },
          ]}
          layout="horizontal"
        >
          <Radio.Group>
            <Radio value="Accepted">Accepted</Radio>
            <Radio value="Declined">Declined</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>

      <Form.Item
        valuePropName="checked"
        name="Checked Voter Registration Page in KEES to confirm update"
      >
        <Checkbox value="Checked Voter Registration Page in KEES to confirm update">
          Checked Voter Registration Page in KEES to confirm update
        </Checkbox>
      </Form.Item>
      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  );
});
export default ScreenNameVR;
